import { numberInputAnatomy as v } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as z, defineStyle as s } from "@chakra-ui/styled-system";
import { cssVar as o, calc as u } from "@chakra-ui/theme-tools";
import x from "../foundations/fontSizes.mjs";
import { runIfFn as f } from "../utils/run-if-fn.mjs";
import { inputTheme as n } from "./input.mjs";
const { defineMultiStyleConfig: _, definePartsStyle: S } = z(v.keys), p = o("number-input-stepper-width"), g = o("number-input-input-padding"), w = u(p).add("0.5rem").toString(), l = o("number-input-bg"), a = o("number-input-color"), d = o("number-input-border-color"), A = s({
  [p.variable]: "sizes.6",
  [g.variable]: w
}), P = s(
  (t) => {
    var e, r;
    return (r = (e = f(n.baseStyle, t)) == null ? void 0 : e.field) != null ? r : {};
  }
), $ = s({
  width: p.reference
}), I = s({
  borderStart: "1px solid",
  borderStartColor: d.reference,
  color: a.reference,
  bg: l.reference,
  [a.variable]: "colors.stories-body-text",
  [d.variable]: "colors.stories-border-color",
  _dark: {
    [a.variable]: "colors.whiteAlpha.800",
    [d.variable]: "colors.whiteAlpha.300"
  },
  _active: {
    [l.variable]: "colors.gray.200",
    _dark: {
      [l.variable]: "colors.whiteAlpha.300"
    }
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  }
}), T = S((t) => {
  var e;
  return {
    root: A,
    field: (e = f(P, t)) != null ? e : {},
    stepperGroup: $,
    stepper: I
  };
});
function i(t) {
  var c, m, b;
  const e = (c = n.sizes) == null ? void 0 : c[t], r = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, y = (b = (m = e.field) == null ? void 0 : m.fontSize) != null ? b : "md", h = x[y];
  return S({
    field: {
      ...e.field,
      paddingInlineEnd: g.reference,
      verticalAlign: "top"
    },
    stepper: {
      fontSize: u(h).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: r[t]
      },
      _last: {
        borderBottomEndRadius: r[t],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
const k = {
  xs: i("xs"),
  sm: i("sm"),
  md: i("md"),
  lg: i("lg")
}, V = _({
  baseStyle: T,
  sizes: k,
  variants: n.variants,
  defaultProps: n.defaultProps
});
export {
  V as numberInputTheme
};
